import Vue from 'vue'

export default new Vue({
  methods: {
    displayNotification(variant, title, text) {
      this.$bvToast.toast(text, {
        variant,
        title,
        solid: true
      })
    },
    displayAPIError(error) {
      if (error.response && error.response.data && error.response.data.message) {
        const errorData = error.response.data

        if (errorData.additional) {
          this.displayError(errorData.message + ': ' + errorData.additional)
        } else if (errorData.exception && errorData.exception.length > 0) {
          const exception = errorData.exception[0]
          this.displayError(`${errorData.message}: (${exception.type}) ${exception.message}`)
        } else {
          this.displayError(error.response.data.message)
        }
      } else {
        this.displayError(error.message || 'An API error has ocurred')
      }
    },
    displayError(errorMessage) {
      this.displayNotification('danger', 'Error', errorMessage)
    },
    displayInformation(message) {
      this.displayNotification('info', 'Information', message)
    },
    displaySuccess(message) {
      this.displayNotification('success', 'Success', message)
    },
    displayWarning(message) {
      this.displayNotification('warning', 'Warning', message)
    }
  }
})
